import { get, put, post } from './api.service';
import { FeatureFlags, FeatureFlagsUpdateInput, ToggleableRole, FeatureName } from '../types';

/**
 * Get current feature flags
 */
export async function getFeatureFlags(): Promise<FeatureFlags> {
  return get<FeatureFlags>('/feature-flags');
}

/**
 * Update feature flags (Super Admin only)
 */
export async function updateFeatureFlags(input: FeatureFlagsUpdateInput): Promise<FeatureFlags> {
  return put<FeatureFlags>('/feature-flags', input);
}

/**
 * Toggle all features on/off for all roles (Super Admin only)
 */
export async function toggleAllFeatures(enabled: boolean): Promise<FeatureFlags> {
  return post<FeatureFlags>('/feature-flags/toggle-all', { enabled });
}

/**
 * Toggle all features for a specific role (Super Admin only)
 */
export async function toggleRoleFeatures(role: ToggleableRole, enabled: boolean): Promise<FeatureFlags> {
  return post<FeatureFlags>('/feature-flags/toggle-role', { role, enabled });
}

/**
 * Toggle a specific feature for a specific role (Super Admin only)
 */
export async function toggleFeature(role: ToggleableRole, feature: FeatureName, enabled: boolean): Promise<FeatureFlags> {
  return post<FeatureFlags>('/feature-flags/toggle-feature', { role, feature, enabled });
}

export default {
  getFeatureFlags,
  updateFeatureFlags,
  toggleAllFeatures,
  toggleRoleFeatures,
  toggleFeature,
};
